module.exports = {
  // URL which site is hosted
  URL : "https://devnullprod.com"
}
